@if (stepChanged$ | async) {
  <div class="category">
    @for (step of steps; track step; let index = $index) {
      @if (getQuestionTotal(step) > 0) {
        <div
          [ngClass]="step === category ? 'current' : ''"
          #selectStep
          class="steps"
        >
          <ng-container>
            <div class="step" (click)="setStep(step, index)">
              <div
                class="step__logo"
                [ngClass]="
                  isCompletedQuestions(step, index) || previous(i)
                    ? 'green-svg'
                    : 'empty-svg'
                "
              >
                @if (stepIconCompleted[step]) {
                  <i class="fa fa-duotone fa-hourglass-half"></i>
                }
                @if (step !== 'Signature' && !stepIconCompleted[step]) {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="12"
                    viewBox="0 0 16 12"
                    fill="none"
                  >
                    <path
                      d="M14.3244 1.65234L5.62848 10.3483L1.67578 6.39559"
                      [attr.stroke]="
                        step == category ||
                        previous(index) ||
                        completedQuestions[step]
                          ? 'white'
                          : '#01A341'
                      "
                      stroke-width="1.58108"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
                @if (step == 'Signature') {
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="11"
                    viewBox="0 0 12 11"
                    fill="none"
                  >
                    <path
                      d="M0.918945 8.90519C0.918945 8.90519 1.55408 8.27006 3.45949 8.27006C5.36489 8.27006 6.63516 9.54033 8.54057 9.54033C10.446 9.54033 11.0811 8.90519 11.0811 8.90519V1.28357C11.0811 1.28357 10.446 1.91871 8.54057 1.91871C6.63516 1.91871 5.36489 0.648438 3.45949 0.648438C1.55408 0.648438 0.918945 1.28357 0.918945 1.28357V8.90519Z"
                      [attr.stroke]="
                        step == category ||
                        previous(index) ||
                        completedQuestions[step]
                          ? 'white'
                          : '#01A341'
                      "
                      stroke-width="1.27027"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                }
              </div>
              <div class="step__title">
                <div class="step__title__name">
                  {{ step }}
                </div>
                @if (step !== 'Signature') {
                  <div class="step__title__questions">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="14"
                      height="15"
                      viewBox="0 0 14 15"
                      fill="none"
                    >
                      <path
                        d="M13 7.16669C13.0023 8.0466 12.7967 8.91461 12.4 9.70002C11.9296 10.6412 11.2065 11.4328 10.3116 11.9862C9.41677 12.5396 8.3855 12.8329 7.33333 12.8334C6.45342 12.8356 5.58541 12.6301 4.8 12.2334L1 13.5L2.26667 9.70002C1.86995 8.91461 1.66437 8.0466 1.66667 7.16669C1.66707 6.11452 1.96041 5.08325 2.51381 4.18839C3.06722 3.29352 3.85884 2.5704 4.8 2.10002C5.58541 1.70331 6.45342 1.49772 7.33333 1.50002H7.66667C9.05623 1.57668 10.3687 2.16319 11.3528 3.14726C12.3368 4.13132 12.9233 5.44379 13 6.83335V7.16669Z"
                        stroke="#0066FF"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <span> {{ getQuestionTotal(step) }} Questions </span>
                  </div>
                }
              </div>
            </div>
            <!-- (previous(index) && step != category) || -->
            @if (step !== 'Signature') {
              @for (i of [1, 2, 3, 4]; track i) {
                <div class="numbers">
                  <div
                    class="number"
                    [ngClass]="getClassSteperDash(step, index, i)"
                  ></div>
                </div>
              }
            }
          </ng-container>
        </div>
      }
    }
  </div>
}
